export const getContent = store => (store.page ? store.page : {});
export const get = store => {
  return getContent(store).page;
};
export const isLoaded = store => {
  let content = getContent(store);
  return content.isLoaded != null && content.isLoaded;
};
